package gr.tech.site

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.ScrollBehavior
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.scrollBehavior
import com.varabyte.kobweb.core.App
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitKobweb
import com.varabyte.kobweb.core.init.InitKobwebContext
import com.varabyte.kobweb.silk.SilkApp
import com.varabyte.kobweb.silk.components.layout.Surface
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.init.registerStyleBase
import com.varabyte.kobweb.silk.style.common.SmoothColorStyle
import com.varabyte.kobweb.silk.style.toModifier
import gr.tech.site.components.layouts.PageLayoutData
import gr.tech.site.pages.NotFoundPage
import org.jetbrains.compose.web.css.vh

//private const val COLOR_MODE_KEY = "site:colorMode"
//
//@InitSilk
//fun initColorMode(ctx: InitSilkContext) {
//    ctx.config.initialColorMode = ColorMode.loadFromLocalStorage(COLOR_MODE_KEY) ?: ColorMode.systemPreference
//}

@InitSilk
fun initStyles(ctx: InitSilkContext) {
    ctx.stylesheet.apply {
        registerStyleBase("body") { Modifier.scrollBehavior(ScrollBehavior.Smooth) }
    }
}

@InitKobweb
fun setCustomErrorPage(ctx: InitKobwebContext) {
    ctx.router.setErrorPage(
        // ".components.layouts.ErrorLayout" won't work here!
        layoutId = "gr.tech.site.components.layouts.PageLayout",
        initRouteMethod = { initRouteCtx ->
            initRouteCtx.data.add(PageLayoutData(
                showContactHeader = true,
                title = "Page Not Found"
            ))
        }
    ) {
        NotFoundPage()
    }
}

@App
@Composable
fun AppEntry(content: @Composable () -> Unit) {
    SilkApp {
//        val colorMode = ColorMode.LIGHT
//        LaunchedEffect(colorMode) {
//            colorMode.saveToLocalStorage(COLOR_MODE_KEY)
//        }
        Surface(SmoothColorStyle.toModifier().minHeight(100.vh)) {
            content()
        }
    }
}
